module.exports = __webpack_public_path__ + "static/fonts/iconfont.ebc1de34.woff";